<template>
  <b-alert
    :show="alertDismissCount"
    dismissible
    fade
    :variant="type"
    @dismiss-count-down="countDownChanged"
  >
    {{text}} ({{ alertDismissCount }})
  </b-alert>
</template>

<script>
export default {
  data() {
    return {
      text: 'Ha ocurrido un error inesperado',
      alertDismissCount: 0,
    };
  },
  props: ['type', 'message'],
  watch: {
    message() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.text = (this.message) ? this.message : this.message;

      this.alertDismissCount = 5;
    },
    countDownChanged(dismissCountDown) {
      this.alertDismissCount = dismissCountDown;

      if (!this.alertDismissCount) {
        this.$emit('update:message', '');
      }
    },
  },
};
</script>
